/* =========================================================================
   Penny Premium 3D — motion.js
   THE motion gate. Decides once what this device/session gets and
   expresses it as classes on <html>. Every effect rule in CSS and every
   "should this animate?" branch in JS keys off these classes — there is
   exactly one answer, and this is it.

     motion-full     everything (Standard or Subtle intensity)
     motion-reduced  reduced-motion / save-data / low-end device
     motion-off      merchant disabled animations
     has-fine-pointer, has-hover  capability classes (tilt etc.)

   Loaded as a tiny synchronous <head> script (~0.7KB) so the classes
   exist at first paint — entrances and reveals never flash. Inputs are
   read from <html data-animations data-motion> (set server-side from
   theme settings) plus media queries and a low-end heuristic.
   ========================================================================= */

(function () {
  var html = document.documentElement;
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqPointer = window.matchMedia('(pointer: fine)');
  var mqHover = window.matchMedia('(hover: hover)');

  var saveData =
    (navigator.connection && navigator.connection.saveData === true) ||
    window.matchMedia('(prefers-reduced-data: reduce)').matches;

  var lowEnd =
    (navigator.deviceMemory && navigator.deviceMemory <= 2) ||
    (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2);

  function apply() {
    html.classList.remove('motion-full', 'motion-reduced', 'motion-off');

    if (html.dataset.animations === 'false') {
      html.classList.add('motion-off');
    } else if (mqReduce.matches || saveData || lowEnd) {
      html.classList.add('motion-reduced');
    } else {
      html.classList.add('motion-full');
    }

    html.classList.toggle('has-fine-pointer', mqPointer.matches);
    html.classList.toggle('has-hover', mqHover.matches);
    html.classList.toggle('motion-subtle', html.dataset.motion === 'subtle');
  }

  apply();
  mqReduce.addEventListener('change', apply);
  mqPointer.addEventListener('change', apply);
  mqHover.addEventListener('change', apply);
})();
